"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PaperPlaneIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M23.541.605a.849.849,0,0,0-.888-.1L.628,10.78a.85.85,0,0,0,.108,1.583l8.679,2.684v7.682a.852.852,0,0,0,.524.786.854.854,0,0,0,.927-.185l4.425-4.425,3.236,2.223A.849.849,0,0,0,19.84,20.6l4-19.157A.851.851,0,0,0,23.541.605ZM19.19,3.993l-9.172,9.461L3.342,11.39ZM11.115,20.678V16.036l2.751,1.89ZM18.438,19,11.575,14.29l10-10.319Z" })));
}
exports.default = PaperPlaneIcon;
